export default __webpack_public_path__ + "static/media/Mockup.e27bb164.png";